module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('h3', {
    staticClass: "tocf"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('h2', {
    staticClass: "tocp"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Part01"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Part I: Nemesis in Salamis")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Chapter01"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 1")])]), _vm._v(" The Invasion of Attica")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter02"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 2")])]), _vm._v(" The Opposing Forces")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter03"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 3")])]), _vm._v(" Jockeying for Positions")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 4")])]), _vm._v(" Setting the Stage")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 5")])]), _vm._v(" The Battle")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 6")])]), _vm._v(" Victory at Sea")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 7")])]), _vm._v(" The Aftermath")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Part II: The Imperial Last Roar")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 8")])]), _vm._v(" The Winter Proceedings of Mardonius")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 9")])]), _vm._v(" The Army of the Conqueror")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 10")])]), _vm._v(" The Winter Quarrels and Machinations of the Allies")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 11")])]), _vm._v(" The Springing of the Spring")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 12")])]), _vm._v(" The Expeditionary Armies of the Defenders")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 13")])]), _vm._v(" On the Dance Floor of War")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 14")])]), _vm._v(" The Opening Moves")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 15")])]), _vm._v(" To Seize or to Forfeit? Initiative Supreme")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 16")])]), _vm._v(" The Decisive Battle")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 17")])]), _vm._v(" The Making of a Triumph")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 18")])]), _vm._v(" The Fat Lady Sang – Again")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Part03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Part III: The Battle of Mycale")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 19")])]), _vm._v(" Sealing the Door Shut")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 20")])]), _vm._v(" The Greek Expedition")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 21")])]), _vm._v(" The Defending Imperials")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 22")])]), _vm._v(" The Allied Assault")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 23")])]), _vm._v(" Aftermath")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocf1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Epilogue")])])]), _vm._v(" "), _c('h3', {
    staticClass: "tocf"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/33_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Bibliography")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-147245f5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 69
// module chunks = 0